import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=66974029&"
import script from "./Departments.vue?vue&type=script&lang=js&"
export * from "./Departments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66974029')) {
      api.createRecord('66974029', component.options)
    } else {
      api.reload('66974029', component.options)
    }
    module.hot.accept("./Departments.vue?vue&type=template&id=66974029&", function () {
      api.rerender('66974029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Admin/Departments.vue"
export default component.exports